"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataStatusIcon = exports.getTooltipAnchorClientRect = exports.DataQualityDetailMessageElement = exports.DataQualityDetailDateElement = exports.DataQualityDetailAuthorElementInner = exports.DataQualityDetailAuthorElement = exports.DataQualityDetailAsset = exports.DataQualityDetailMessageId = exports.DataQualityDetailChipId = void 0;
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var icons_1 = require("../../../gen-src/icons");
var SpacesDataStatus_1 = __importDefault(require("../../../gen-src/icons/SpacesDataStatus"));
var SpacesDataStatusActive_1 = __importDefault(require("../../../gen-src/icons/SpacesDataStatusActive"));
var WarningHighSeverity_1 = __importDefault(require("../../../gen-src/icons/WarningHighSeverity"));
var WarningHighSeverityActive_1 = __importDefault(require("../../../gen-src/icons/WarningHighSeverityActive"));
var UserDisplayComponent_1 = require("../UserDisplayComponent");
var ViewerPaneLayoutComponents_1 = require("../ViewerPaneLayoutComponents");
var RemoteTypeIcon_1 = require("../dataGrid/cellFormatters/RemoteTypeIcon");
var DataQualityIndicatorStyles_1 = require("../style/DataQualityIndicatorStyles");
var MarkupStyles_1 = require("../style/MarkupStyles");
var StyleConstants_1 = require("../style/StyleConstants");
var VizPortalStyles_1 = require("../style/VizPortalStyles");
var StringInterpolation_1 = require("../utils/StringInterpolation");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
/**
 * @deprecated TFS-1478812
*/
exports.DataQualityDetailChipId = 'data-quality-detail-chip-id';
/**
 * @deprecated TFS-1478812
*/
exports.DataQualityDetailMessageId = 'data-quality-detail-message-id';
function assetIconForType(typename, remoteType) {
    switch (typename) {
        case null:
            return null;
        case 'CloudFile':
        case 'File':
            return react_1.default.createElement(icons_1.SvgSpacesMediumFile, null);
        case 'DatabaseServer':
        case 'WebDataConnector':
            return react_1.default.createElement(icons_1.SvgSpacesMediumExternalServer, null);
        case 'DatabaseTable':
            return react_1.default.createElement(icons_1.SvgSpacesMediumTable, null);
        case 'Flow':
            return react_1.default.createElement(icons_1.SvgSpacesMediumFlow, null);
        case 'PublishedDatasource':
            return react_1.default.createElement(icons_1.SvgSpacesMediumDs, null);
        case 'Column':
            return remoteType ? react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: remoteType }) : null;
        case 'VirtualConnection':
            return react_1.default.createElement(icons_1.SvgVirtualConnection, null);
        case 'VirtualConnectionTable':
            return react_1.default.createElement(icons_1.SvgVirtualConnectionTable, null);
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(typename);
            return null;
    }
}
function getPermissionRequiredMessage() {
    var name = Localize_1.Messages.PermissionRequired();
    return react_1.default.createElement("span", { key: 'asset-' + name, style: DataQualityIndicatorStyles_1.IndicatorDetailPermissionRequired }, name);
}
/**
 * @deprecated TFS-1478812
*/
function DataQualityDetailAsset(props) {
    if (props.assetName === null) {
        return getPermissionRequiredMessage();
    }
    var iconComponent = assetIconForType(props.assetType, props.remoteType);
    return (react_1.default.createElement(DataQualityIndicatorStyles_1.IndicatorDetailAssetStyle, null, props.assetUrl ?
        react_1.default.createElement(ViewerPaneLayoutComponents_1.SingleLineLinkWithIcon, { linkText: props.assetName || null, linkHref: props.assetUrl, iconComponent: iconComponent, iconSize: 'small' }) :
        react_1.default.createElement(ViewerPaneLayoutComponents_1.SingleLineTextWithIcon, { text: props.assetName || null, iconComponent: iconComponent, iconSize: 'small' })));
}
exports.DataQualityDetailAsset = DataQualityDetailAsset;
function DataQualityAuthorLink(props) {
    return react_1.default.createElement("a", { href: props.url, target: '_blank', className: VizPortalStyles_1.linkClass, title: props.name, rel: "noreferrer" }, props.name);
}
/**
 * @deprecated TFS-1478812
*/
function DataQualityDetailAuthorElement(props) {
    return (react_1.default.createElement(DataQualityIndicatorStyles_1.IndicatorDetailAuthorStyle, null,
        react_1.default.createElement(DataQualityDetailAuthorElementInner, __assign({}, props))));
}
exports.DataQualityDetailAuthorElement = DataQualityDetailAuthorElement;
/**
 * @deprecated TFS-1478812
*/
function DataQualityDetailAuthorElementInner(props) {
    var userElement = props.linksDisabled
        ? react_1.default.createElement(UserDisplayComponent_1.UserTextDisplayComponent, { user: props.author })
        : react_1.default.createElement(UserDisplayComponent_1.UserLinkDisplayComponent, { user: props.author, linkComponent: DataQualityAuthorLink });
    var name = '[AUTHOR_NAME_TOKEN]';
    var span = react_1.default.createElement("span", { key: 'author', "data-tb-test-id": 'Data-Quality-Detail-Author' }, userElement);
    switch (props.kind) {
        case 'severe-warning':
        case 'standard-warning':
            return (react_1.default.createElement(react_1.default.Fragment, null, (0, StringInterpolation_1.interpolateString)(Localize_1.Messages.DataQualityAuthor({ name: name }), { 'AUTHOR_NAME_TOKEN': span })));
        case 'certification':
            return (react_1.default.createElement(react_1.default.Fragment, null, (0, StringInterpolation_1.interpolateString)(Localize_1.Messages.DataQualityCertificationAuthor({ name: name }), { 'AUTHOR_NAME_TOKEN': span })));
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(props.kind);
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
exports.DataQualityDetailAuthorElementInner = DataQualityDetailAuthorElementInner;
/**
 * @deprecated TFS-1478812
*/
function DataQualityDetailDateElement(props) {
    return (react_1.default.createElement(DataQualityIndicatorStyles_1.IndicatorDetailDateStyle, null, props.localizedDate));
}
exports.DataQualityDetailDateElement = DataQualityDetailDateElement;
function MarkupOrSplitString(props) {
    var message = props.message, linksDisabled = props.linksDisabled;
    var messageOrBlank = message || '';
    return (react_1.default.createElement(MarkupStyles_1.FormattedMarkupWrapperInTooltip, { markup: messageOrBlank, linksDisabled: linksDisabled }));
}
/**
 * @deprecated TFS-1478812
*/
function DataQualityDetailMessageElement(props) {
    if (props.assetName === null) {
        return (react_1.default.createElement(DataQualityIndicatorStyles_1.IndicatorDetailMessageStyle, { id: exports.DataQualityDetailMessageId }, Localize_1.Messages.PermissionRequiredMessage()));
    }
    return (react_1.default.createElement(DataQualityIndicatorStyles_1.IndicatorDetailMessageStyle, null,
        react_1.default.createElement(MarkupOrSplitString, __assign({}, props))));
}
exports.DataQualityDetailMessageElement = DataQualityDetailMessageElement;
/**
 * @deprecated TFS-1478812
*/
function getTooltipAnchorClientRect(el) {
    if (el) {
        var clientRect = el.getBoundingClientRect();
        return {
            left: clientRect.left - StyleConstants_1.DataQualityDetailPanelWidth,
            right: clientRect.right,
            top: clientRect.top,
            bottom: clientRect.bottom,
        };
    }
    return {};
}
exports.getTooltipAnchorClientRect = getTooltipAnchorClientRect;
function DataStatusAnchored(props) {
    if (props.hover) {
        return props.isSevere ?
            react_1.default.createElement(WarningHighSeverityActive_1.default, { className: DataQualityIndicatorStyles_1.IndicatorStatusChipIconClass }) :
            react_1.default.createElement(SpacesDataStatusActive_1.default, { className: DataQualityIndicatorStyles_1.IndicatorStatusChipIconClass });
    }
    else {
        return props.isSevere ?
            react_1.default.createElement(WarningHighSeverity_1.default, { className: DataQualityIndicatorStyles_1.IndicatorStatusChipIconClass }) :
            react_1.default.createElement(SpacesDataStatus_1.default, { className: DataQualityIndicatorStyles_1.IndicatorStatusChipIconClass });
    }
}
/**
 * @deprecated TFS-1478812
*/
function DataStatusIcon(props) {
    return (react_1.default.createElement(DataStatusAnchored, { hover: props.hover, isSevere: props.isSevere }));
}
exports.DataStatusIcon = DataStatusIcon;
//# sourceMappingURL=DataQualityIndicatorSharedHelpers.js.map